<template>
  <div class="mt-21">
    <div v-if="isOnline">
      <div v-if="initial_loading_done">
        <customization-panel
          v-if="isCustomizationLoaded && is_web_admin"
        ></customization-panel>
        <Topbar v-if="customizationLocal.topbar_availability" />
        <NavBar></NavBar>
        <router-view />
        <Footer></Footer>
        <item-detail></item-detail>
        <!-- <MobileModifier> </MobileModifier> -->
      </div>
      <!-- <div v-else class="initial-loading-indicator">
      LOADING...
    </div>-->
      <SkeletonLoader v-else />
    </div>
    <OfflinePage v-else />
    <Notification class="no-print" />
    <cart-alert class="no-print"></cart-alert>
    <select-delivery-area></select-delivery-area>
    <!-- <DAStorePicker /> -->
  </div>
</template>

<script>
// import DAStorePicker from '@/components/Modals/DAStorePicker.vue'
import { mapGetters } from 'vuex'
import NavBar from '@/components/NaigateBar/NavBar'
import Notification from '@/components/Elements/Notifications'
import CartAlert from '@/components/Elements/CartAlert'
import OfflinePage from '@/components/ErrorPages/Offline'
import Footer from '@/components/Footer/Footer'
import SkeletonLoader from '@/components/Elements/SkeletonLoader'
import ItemDetail from '@/components/Blocks/Cart/Items/ItemDetail'
import CustomizationPanel from '@/components/Modals/CustomizationPanel'
import Topbar from '@/components/NaigateBar/Topbar'
import selectDeliveryArea from '@/components/SelectDeliveryArea'
// import MobileModifier from '@/components/Blocks/Cart/MobileModifier'
import Vue from 'vue'
import VueAnalytics from 'vue-analytics'
import router from './router/router'

import PWA from '@/mixins/PWA'

export default {
  name: 'App',
  components: {
    selectDeliveryArea,
    NavBar,
    Notification,
    Topbar,
    CartAlert,
    OfflinePage,
    Footer,
    SkeletonLoader,
    ItemDetail,
    CustomizationPanel,
    // DAStorePicker,
    // MobileModifier
  },

  watch: {
    initial_loading_done: {
      //data loaded
      immediate: true,
      handler(val) {
        if (val) {
          if (this.currentBrand && this.domainBasedBrand) {
            this.$nextTick(() => {
              this.setupBrandWebsite()
            })
          } else {
            document.title = 'Go Order'
            this.addFavicon('/images/favicon.png')
          }
        }
      },
    },
  },
  mixins:[PWA],
  computed: {
    ...mapGetters([
      '_T',
      'initial_loading_done',
      'customizationLocal',
      'isCustomizationLoaded',
      'domainBasedBrand',
      'currentBrand',
      'is_web_admin',
    ]),
  },
  methods: {
    setupBrandWebsite() {
      if (this.currentBrand.meta_description) {
        document
          .querySelector('meta[name="description"]')
          .setAttribute('content', this.currentBrand.meta_description)
      }
      if (this.currentBrand.website_keywords) {
        document
          .querySelector('meta[name="keywords"]')
          .setAttribute('content', this.currentBrand.website_keywords)
      }
      document.title = this.currentBrand.meta_title || this.currentBrand.name
      this.addFavicon(this.currentBrand.web_favicon)
      const brandGoogleAnalyticsCode = this.currentBrand.google_analytics_code
      const facebookPixelCode = this.currentBrand.facebook_pixel_code
      if (brandGoogleAnalyticsCode) {
        this.appendGoogleAnalyticsCode(brandGoogleAnalyticsCode)
      }
      if (facebookPixelCode) {
        this.appendFacebookPixelCode(facebookPixelCode)
      }

      if (window.fbq) {
        window.fbq('trackCustom', document.title, {
          user: this.$store.getters.web_user,
        })
      }

      if (this.$route.params.category_name) {
        this.$store.dispatch(
          'resolveCategory',
          this.$route.params.category_name
        )
      }
    },
    appendGoogleAnalyticsCode(code) {
      const script = document.createElement('script')
      script.src = `https://www.googletagmanager.com/gtag/js?id=${code}`
      script.async = true
      document.head.appendChild(script)

      const scriptFunc = document.createElement('script')
      scriptFunc.text = `
        window.dataLayer = window.dataLayer || [];
        function gtag(){dataLayer.push(arguments);}
        gtag('js', new Date());
        gtag('config', '${code}');
      `
      document.head.appendChild(scriptFunc)

      Vue.use(VueAnalytics, {
        id: code,
        router,
        autoTracking: {
          screenview: true,
          pageviewOnLoad: false,
        },
      })
    },
    appendFacebookPixelCode(code) {
      const scriptFunc = document.createElement('script')
      scriptFunc.text = `
      !function(f,b,e,v,n,t,s)
        {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
        n.callMethod.apply(n,arguments):n.queue.push(arguments)};
        if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
        n.queue=[];t=b.createElement(e);t.async=!0;
        t.src=v;s=b.getElementsByTagName(e)[0];
        s.parentNode.insertBefore(t,s)}(window, document,'script',
        'https://connect.facebook.net/en_US/fbevents.js');
        fbq('init', '${code}');
      `
      const noScriptTag = document.createElement('noscript')
      noScriptTag.text = `
      <img height="1" width="1" style="display:none"
        src="https://www.facebook.com/tr?id=${code}&ev=PageView&noscript=1"
      />
      `

      document.head.appendChild(scriptFunc)
      document.head.appendChild(noScriptTag)
    },
    addFavicon(href) {
      const link =
        document.querySelector("link[rel*='icon']") ||
        document.createElement('link')
      link.rel = 'icon'
      link.href = href
      document.getElementsByTagName('head')[0].appendChild(link)
    },
  },
  mounted() {
    this.$store.dispatch('initializeSystem')
    /* this code is to resolve touch bar issue in iphone mobile devices */
    let isIOS =
      /iPad|iPhone|iPod/.test(window.navigator.userAget) ||
      (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1)
    if (isIOS) {
      // Will improve it later when we have some proper solution to target iPhone devices
      document.body.style.setProperty('-webkit-overflow-scrolling', 'touch')
      document.body.style.setProperty('height', '100% !important')
      document.body.style.setProperty('overflow-y', 'auto !important')
      document
        .getElementsByTagName('html')[0]
        .setAttribute('-webkit-overflow-scrolling', 'touch')
      document
        .getElementsByTagName('html')[0]
        .setAttribute('overflow-y', 'auto !important')
      document
        .getElementsByTagName('html')[0]
        .setAttribute('height', '100% !important')
    }
  },
  created() {
    this.$store.dispatch('generate_manifest_url')
  },
}
</script>

<style lang="scss">
@import 'scss/main.scss';
html {
  // @supports (-webkit-touch-callout: none) {
  //   -webkit-overflow-scrolling: touch;
  //   height: 100%;
  //   overflow-y: auto;
  // }
}

#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
}
.initial-loading-indicator {
  position: fixed;
  width: 100%;
  height: 100%;
  text-align: center;
  top: 30%;
  font-size: 3rem;
}

.mt-21 {
  margin-top: -$px21;
}
#onesignal-slidedown-container #onesignal-slidedown-dialog {
  .slidedown-body-icon {
    height: auto !important;
    img {
      height: auto !important;
    }
  }
  .slidedown-body {
    display: flex !important;
    align-items: center !important;
  }
}

</style>
